export default Object.freeze({
  CREATE_PROJECT: 10_010,
  EDIT_PROJECT: 10_011,
  DELETE_PROJECT: 10_012,
  ADD_DEVICE: 10_020,
  DELETE_DEVICE: 10_022,
  ADD_USER: 10_030,
  DELETE_USER: 10_032,
  ADD_ALERT: 10_040,
  EDIT_ALERT: 10_041,
  DELETE_ALERT: 10_042,
  ADD_PRODUCT: 10_050,
  EDIT_PRODUCT: 10_051,
  DELETE_PRODUCT: 10_052,
  ADD_PACKAGE_TYPE: 10_060,
  EDIT_PACKAGE_TYPE: 10_061,
  DELETE_PACKAGE_TYPE: 10_062,
  ASSIGN_MODULE_TO_PROJECT: 10_070,
  UNASSIGN_MODULE_FROM_PROJECT: 10_072,
  ADD_CUSTOM_FIELD: 10_080,
  EDIT_CUSTOM_FIELD: 10_081,
  DELETE_CUSTOM_FIELD: 10_082,
  CREATE_ALERT_CONFIRMATION: 10_090,
  EDIT_ALERT_CONFIRMATION: 10_091,
  DELETE_ALERT_CONFIRMATION: 10_092
});
